import styled from 'styled-components'
import Arrow from './Arrow'
import { rem } from 'polished'

const Line = styled.div`
  width: 100%;
  height: ${rem(2)};
  background-color: currentColor;

  @media print {
    width: 100%;
    height: ${rem(2)};
    background-color: black !important;
  }
`

const Edge = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  -webkit-print-color-adjust:exact !important;
  print-color-adjust:exact !important;
`

const PositionedArrow = styled(Arrow)`
  --full-arrow-inline-offset: 33%;

  position: absolute;
  inset-inline-end: 0;
  top: 50%;
  transform: translateY(-50%) translateX(var(--full-arrow-inline-offset));
  stroke: currentColor;
  stroke-width: 2px;

  [dir='rtl'] & {
    --full-arrow-inline-offset: -33%;
  }
`

interface Props {
  arrowSize?: number
  className?: string
  width?: number | string
  minWidth?: number | string
  height?: number
}

function FullArrow(props: Props) {
  const { arrowSize, className, height, width, minWidth } = props
  const style = {
    height,
    width,
    minWidth,
  }
  return (
    <Edge className={className} style={style}>
      <Line />
      <PositionedArrow size={arrowSize} />
    </Edge>
  )
}

FullArrow.defaultProps = {
  arrowSize: 16,
}

export default FullArrow
